export default __webpack_public_path__ + "static/media/post-suvinil9.b6e0f6ac.png";